import { Dispatch } from 'redux';
import { ActionType, IDispatchAction } from '../reducers/mainReducer';

export class MainActions {
  private readonly dispatch: Dispatch<IDispatchAction>;

  constructor(dispatch: Dispatch<IDispatchAction>) {
    this.dispatch = dispatch;
  }

  setWaiting = (waiting: boolean) => {
    return this.dispatch({
      type: ActionType.SetWaiting,
      payload: {
        waiting: waiting
      }
    });
  }

  setNotWait = (notwait: boolean) => {
    return this.dispatch({
      type: ActionType.SetNotWait,
      payload: {
        notwait: notwait
      }
    });
  }

  setSessionIsExpiring = (sessionIsExpiring: boolean) => {
    return this.dispatch({
      type: ActionType.SetSessionIsExpiring,
      payload: {
        sessionIsExpiring: sessionIsExpiring
      }
    });
  }

  // otherAction = (parameter1: string) => {
  //     return this.dispatch({
  //         type: ActionType.Type1,
  //         payload: {
  //             property1: parameter1
  //         }
  //     });
  // }
}